import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Component({
  selector: 'app-my-school-add-instructor',
  templateUrl: './my-school-add-instructor.component.html',
  styleUrls: ['./my-school-add-instructor.component.css']
})
export class MySchoolAddInstructorComponent implements OnInit {

  valid = true;
  constructor(
    public dialogRef: MatDialogRef<MySchoolAddInstructorComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {}

  emailFormControl = new FormControl('', [
      Validators.required,
      Validators.email,
  ]);
  matcher = new MyErrorStateMatcher();
  onCancel(): void {
    this.dialogRef.close();
  }
  ngOnInit():void{

  }
  validateEmail(email){
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.valid = re.test(String(email).toLowerCase());
    return this.valid
}

}

